module.exports = __webpack_public_path__ + "img/vlaamserand.f99c85d5.jpg";